import { d3 as useModuleContext, dP as createApi, d2 as apiBaseQuery, bb as skipToken, c as classNames, U as FontAwesomeIcon, ai as createClassName, u as useStrings, o as useNavigation, bg as useGetDocumentMetadataQuery, a8 as Link, bN as __rest, F as __awaiter, X as joinPath, dM as getVehicleRoot } from './chunks/className-0524835a.js';
import React__default, { useMemo, useState, Fragment, useRef } from 'react';
import { f as faExclamationExports } from './chunks/faExclamation-ad6be19e.js';
import { a as SkeletonContainer, b as Skeleton, d as faExclamationCircleExports, S as Skeleton$1, P as Panel } from './chunks/SkeletonContainer-fd90b3af.js';
import { P as PanelGrid } from './chunks/PanelGrid-8e806ad8.js';
import { f as faCheckCircleExports } from './chunks/faCheckCircle-0376b394.js';
import { I as IconButton, f as faTimesExports } from './chunks/Portal-0a1b6f69.js';
import { D as DateText } from './chunks/DateText-ac378e62.js';
import { u as useApiErrorMessage } from './chunks/errorMessages-f4eb0f49.js';
import { T as Text } from './chunks/Text-45e81862.js';
import { u as useOnMobile } from './chunks/mediaQueries-5d7be706.js';
import { T as TickBox } from './chunks/TickBox-7d6e678a.js';
import 'react-redux';
import 'react-dom';
import 'react/jsx-runtime';

const campaignsModuleId = Symbol('campaignsModule');
const useCampaignsContext = () => useModuleContext(campaignsModuleId);

const campaignsApi = createApi({
    reducerPath: 'campaignsApi',
    baseQuery: apiBaseQuery(),
    tagTypes: ['Campaigns'],
    endpoints: builder => ({
        getCampaigns: builder.query({
            query: vin => `/campaigns/vehicles/${vin}`,
            providesTags: (result, error, vin) => {
                return result ? [{ type: 'Campaigns', id: vin }] : [];
            },
            extraOptions: {
                timeout: 60000
            }
        })
    })
});
const { useGetCampaignsQuery } = campaignsApi;

const CampaignsBadge = ({ vehicle, preloadedCampaigns }) => {
    var _a;
    const { strings: { campaigns: strings } } = useCampaignsContext();
    const { data, isLoading, isError } = useGetCampaignsQuery(preloadedCampaigns ? skipToken : vehicle.vin);
    const campaigns = preloadedCampaigns !== null && preloadedCampaigns !== void 0 ? preloadedCampaigns : data;
    const campaignCount = (_a = campaigns === null || campaigns === void 0 ? void 0 : campaigns.activeCount) !== null && _a !== void 0 ? _a : campaigns === null || campaigns === void 0 ? void 0 : campaigns.campaigns.length;
    const badgeClasses = classNames(className$6('badge'), {
        [className$6('zero')]: campaignCount === 0
    });
    return React__default.createElement("div", { className: className$6() }, (() => {
        if (isLoading) {
            return React__default.createElement(SkeletonContainer, null,
                React__default.createElement(Skeleton, { variant: "circular", width: 20, height: 20 }));
        }
        return React__default.createElement("div", { className: badgeClasses, role: "status" }, isError ? React__default.createElement(FontAwesomeIcon, { icon: faExclamationExports.faExclamation, size: "sm", title: strings.campaignsLoadError }) : campaignCount);
    })());
};
const className$6 = createClassName('CampaignsBadge');

const CampaignsSidebarItem = ({ vehicle }) => {
    const { strings: { campaigns: strings } } = useCampaignsContext();
    return React__default.createElement("div", { className: className$5() },
        strings.title,
        React__default.createElement(CampaignsBadge, { vehicle: vehicle }));
};
const className$5 = createClassName('CampaignsSidebarItem');

var faWrench = {};

var hasRequiredFaWrench;

function requireFaWrench () {
	if (hasRequiredFaWrench) return faWrench;
	hasRequiredFaWrench = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'wrench';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f0ad';
		var svgPathData = 'M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faWrench = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faWrench));
	return faWrench;
}

var faWrenchExports = requireFaWrench();

const CampaignIcon = ({ campaign, size }) => {
    const { iconResolver } = useCampaignsContext();
    const customIcon = useMemo(() => iconResolver === null || iconResolver === void 0 ? void 0 : iconResolver(campaign), [iconResolver, campaign]);
    const classes = classNames(className$4(), customIcon === null || customIcon === void 0 ? void 0 : customIcon.className, (campaign === null || campaign === void 0 ? void 0 : campaign.icon) && !customIcon && className$4(campaign.icon.toLowerCase()));
    const icon = useMemo(() => {
        if (customIcon) {
            return customIcon.icon;
        }
        switch (campaign.icon) {
            case 'SHOULD':
                return faWrenchExports.faWrench;
            case 'MUST':
                return faExclamationCircleExports.faExclamationCircle;
            case 'COMPLETE':
                return faCheckCircleExports.faCheckCircle;
        }
    }, [customIcon, campaign.icon]);
    return icon ? React__default.createElement(FontAwesomeIcon, { className: classes, icon: icon, size: size }) : null;
};
const className$4 = createClassName('CampaignIcon');

const CampaignDocumentLink = ({ documentId, vehicle, preloadedDocuments, getDocumentUrl }) => {
    var _a, _b;
    const { document: strings } = useStrings();
    const navigation = useNavigation();
    const { data: document, error } = useGetDocumentMetadataQuery(preloadedDocuments ? skipToken : documentId);
    const preloadedDocument = preloadedDocuments === null || preloadedDocuments === void 0 ? void 0 : preloadedDocuments.find(document => document.id === documentId);
    const title = (_a = preloadedDocument === null || preloadedDocument === void 0 ? void 0 : preloadedDocument.title) !== null && _a !== void 0 ? _a : document === null || document === void 0 ? void 0 : document.title;
    const apiErrorMessage = useApiErrorMessage(strings.loadError, error, {
        404: strings.notFound
    });
    const errorMessage = preloadedDocuments && !preloadedDocument ? strings.notFound : apiErrorMessage;
    if (errorMessage) {
        return React__default.createElement(React__default.Fragment, null, errorMessage);
    }
    if (!title) {
        return React__default.createElement(Skeleton$1, { role: "progressbar", width: "60%" });
    }
    return React__default.createElement(Link, { href: (_b = getDocumentUrl === null || getDocumentUrl === void 0 ? void 0 : getDocumentUrl(documentId)) !== null && _b !== void 0 ? _b : navigation.document({
            id: documentId,
            documentTypeContentType: null,
            vehicle,
            groupId: null,
            search: null
        }), preventIfOffline: preloadedDocument ? false : strings.cannotOpenOffline }, title);
};

function renderCampaignPropertyValue(property) {
    switch (property.type) {
        case 'url':
            return React__default.createElement(Link, { href: property.value }, property.value);
        case 'date':
            return React__default.createElement(DateText, { date: property.value, format: DateText.DATE_LONG });
        case 'date-time':
            return React__default.createElement(DateText, { date: property.value, format: DateText.DATETIME_LONG });
        default:
            return React__default.createElement(Text, null, property.value);
    }
}
function useCampaigns({ vehicle, preloadedCampaigns, showFilters = false }) {
    var _a;
    const { data, isError } = useGetCampaignsQuery(preloadedCampaigns ? skipToken : vehicle.vin);
    const campaigns = preloadedCampaigns !== null && preloadedCampaigns !== void 0 ? preloadedCampaigns : data;
    const completedCampaigns = useMemo(() => (campaigns === null || campaigns === void 0 ? void 0 : campaigns.campaigns.filter(({ icon }) => icon === 'COMPLETE')) || [], [campaigns]);
    const incompleteCampaigns = useMemo(() => (campaigns === null || campaigns === void 0 ? void 0 : campaigns.campaigns.filter(({ icon }) => icon !== 'COMPLETE')) || [], [campaigns]);
    const [isCompleteFilterOn, setIsCompleteFilterOn] = useState(true);
    const [isIncompleteFilterOn, setIsIncompleteFilterOn] = useState(true);
    const toggleCompleteFilter = (value) => setIsCompleteFilterOn(value);
    const toggleIncompleteFilter = (value) => setIsIncompleteFilterOn(value);
    const showAll = !showFilters || (isCompleteFilterOn && isIncompleteFilterOn);
    const showCompleted = isCompleteFilterOn && !isIncompleteFilterOn;
    const showIncomplete = !isCompleteFilterOn && isIncompleteFilterOn;
    return {
        isError,
        isCompleteFilterOn,
        isIncompleteFilterOn,
        toggleCompleteFilter,
        toggleIncompleteFilter,
        campaigns: showAll ? campaigns === null || campaigns === void 0 ? void 0 : campaigns.campaigns : showIncomplete ? incompleteCampaigns : showCompleted ? completedCampaigns : [],
        banner: (_a = campaigns === null || campaigns === void 0 ? void 0 : campaigns.properties) === null || _a === void 0 ? void 0 : _a.banner
    };
}

const CampaignPanel = ({ campaign, vehicle, preloadedDocuments, getDocumentUrl, onClose }) => {
    var _a;
    const { strings } = useCampaignsContext();
    const _b = (_a = campaign.properties) !== null && _a !== void 0 ? _a : { description: undefined }, { description } = _b, properties = __rest(_b, ["description"]);
    return React__default.createElement(Panel, { className: className$3() },
        React__default.createElement("div", { className: className$3('header') },
            React__default.createElement(CampaignIcon, { campaign: campaign, size: "lg" }),
            React__default.createElement("h3", null, campaign.title),
            React__default.createElement(IconButton, { icon: faTimesExports.faTimes, iconSize: "lg", title: strings.buttons.close, onClick: onClose })),
        description && React__default.createElement("div", { className: className$3('description') }, renderCampaignPropertyValue(description)),
        React__default.createElement("dl", null,
            React__default.createElement("dt", { id: className$3('reference') }, strings.campaigns.reference),
            React__default.createElement("dd", { "aria-labelledby": className$3('reference') }, campaign.reference),
            campaign.date && React__default.createElement(React__default.Fragment, null,
                React__default.createElement("dt", { id: className$3('date') }, strings.message.dateLabel),
                React__default.createElement("dd", { "aria-labelledby": className$3('date') },
                    React__default.createElement(DateText, { date: campaign.date }))),
            campaign.documentId && React__default.createElement(React__default.Fragment, null,
                React__default.createElement("dt", { id: className$3('document') }, strings.campaigns.document),
                React__default.createElement("dd", { "aria-labelledby": className$3('document') },
                    React__default.createElement(CampaignDocumentLink, { documentId: campaign.documentId, vehicle: vehicle, preloadedDocuments: preloadedDocuments, getDocumentUrl: getDocumentUrl }))),
            Object.entries(properties).map(([key, property]) => {
                const id = className$3(`property-${key}`);
                return React__default.createElement(Fragment, { key: key },
                    React__default.createElement("dt", { id: id }, property.title),
                    React__default.createElement("dd", { "aria-labelledby": id }, renderCampaignPropertyValue(property)));
            })));
};
const className$3 = createClassName('CampaignPanel');

const CampaignListSkeleton = ({ hasRole }) => {
    return React__default.createElement(SkeletonContainer, { className: className$2(), hasRole: hasRole },
        React__default.createElement("div", { className: className$2('item') },
            React__default.createElement(Skeleton, { variant: "circular", width: 16, height: 16 }),
            React__default.createElement(Skeleton, { width: "35%", minWidth: 150 }),
            React__default.createElement(Skeleton, { width: "20%", minWidth: 80 })),
        React__default.createElement("div", { className: className$2('item') },
            React__default.createElement(Skeleton, { variant: "circular", width: 16, height: 16 }),
            React__default.createElement(Skeleton, { width: "25%", minWidth: 100 }),
            React__default.createElement(Skeleton, { width: "25%", minWidth: 110 })),
        React__default.createElement("div", { className: className$2('item') },
            React__default.createElement(Skeleton, { variant: "circular", width: 16, height: 16 }),
            React__default.createElement(Skeleton, { width: "45%", minWidth: 200 }),
            React__default.createElement(Skeleton, { width: "15%", minWidth: 50 })));
};
const className$2 = createClassName('CampaignListSkeleton');

const CampaignListPanel = ({ campaigns, isError, selectedCampaign, onSelect }) => {
    const { strings: { campaigns: strings } } = useCampaignsContext();
    return React__default.createElement(Panel, { className: className$1() }, (() => {
        if (isError) {
            return React__default.createElement(Panel.Message, { text: strings.campaignsLoadError });
        }
        if (!campaigns) {
            return React__default.createElement(CampaignListSkeleton, null);
        }
        if (campaigns.length === 0) {
            return React__default.createElement(Panel.Message, { text: strings.noCampaigns });
        }
        return React__default.createElement("ul", { "aria-label": strings.title }, campaigns.map(campaign => {
            return React__default.createElement("li", { key: campaign.reference + campaign.title, "aria-label": campaign.title, "aria-current": campaign === selectedCampaign },
                React__default.createElement("button", { "aria-label": campaign.title, onClick: () => onSelect(campaign) },
                    React__default.createElement(CampaignIcon, { campaign: campaign }),
                    React__default.createElement("div", { className: className$1('title') }, campaign.title),
                    campaign.date && React__default.createElement("div", { className: className$1('date') },
                        React__default.createElement(DateText, { date: campaign.date, relative: DateText.RELATIVE_LONG }))));
        }));
    })());
};
const className$1 = createClassName('CampaignListPanel');

const CampaignsVehicleTab = ({ vehicle, preloadedCampaigns, preloadedDocuments, getDocumentUrl }) => {
    const { strings: { campaigns: strings }, showFilters } = useCampaignsContext();
    const { isError, campaigns, banner, isCompleteFilterOn, isIncompleteFilterOn, toggleCompleteFilter, toggleIncompleteFilter } = useCampaigns({ vehicle, preloadedCampaigns, showFilters });
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const scrollRef = useRef(null);
    const onMobile = useOnMobile();
    const classes = classNames(className(), {
        [className('withSelection')]: selectedCampaign
    });
    function selectCampaign(campaign) {
        var _a;
        setSelectedCampaign(campaign);
        if (onMobile) {
            (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
    return React__default.createElement(PanelGrid, { className: classes },
        banner && React__default.createElement(Panel, { className: className('banner') },
            React__default.createElement(Panel.Content, null, renderCampaignPropertyValue(banner))),
        showFilters && React__default.createElement(Panel, { className: className('filters-container') },
            React__default.createElement(Panel.Content, { className: className('filters') },
                React__default.createElement(TickBox, { id: "FilterCompleteCampaigns", label: strings.completeFilterLabel, value: isCompleteFilterOn, onChange: toggleCompleteFilter }),
                React__default.createElement(TickBox, { id: "FilterIncompleteCampaigns", label: strings.incompleteFilterLabel, value: isIncompleteFilterOn, onChange: toggleIncompleteFilter }))),
        React__default.createElement(PanelGrid.Column, null,
            React__default.createElement(CampaignListPanel, { campaigns: campaigns, isError: isError, selectedCampaign: selectedCampaign, onSelect: selectCampaign }),
            React__default.createElement("div", { className: className('scroll'), ref: scrollRef })),
        selectedCampaign && React__default.createElement(PanelGrid.Column, null,
            React__default.createElement(CampaignPanel, { campaign: selectedCampaign, vehicle: vehicle, preloadedDocuments: preloadedDocuments, getDocumentUrl: getDocumentUrl, onClose: () => setSelectedCampaign(null) })));
};
const className = createClassName('CampaignsVehicleTab');

const reducers = {
    [campaignsApi.reducerPath]: campaignsApi.reducer
};
const middleware = [
    campaignsApi.middleware
];

const CampaignsVehicleTabSkeleton = () => {
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(PanelGrid, null,
            React__default.createElement(Panel, null,
                React__default.createElement(CampaignListSkeleton, { hasRole: false }))));
};

function campaignsBriefcaseExtension() {
    return {
        name: 'campaigns',
        version: 1,
        moduleId: campaignsModuleId,
        displayName(strings) {
            return strings.campaigns.title;
        },
        data(vehicle, dispatch) {
            return __awaiter(this, void 0, void 0, function* () {
                if (vehicle.ref !== 'vin') {
                    return null;
                }
                return dispatch(campaignsApi.endpoints.getCampaigns.initiate(vehicle.vin, { forceRefetch: true })).unwrap();
            });
        },
        documentIds(_vehicle, data, _dispatch) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                return (_a = data === null || data === void 0 ? void 0 : data.campaigns.flatMap(campaign => (campaign.documentId ? [campaign.documentId] : []))) !== null && _a !== void 0 ? _a : [];
            });
        },
        Tab({ Tab, tabProps, vehicle, data }) {
            const { strings } = useCampaignsContext();
            if (vehicle.ref !== 'vin' || !data) {
                return null;
            }
            return React__default.createElement(Tab, { tabProps: tabProps, title: strings.campaigns.title, adornment: React__default.createElement(CampaignsBadge, { vehicle: vehicle, preloadedCampaigns: data }) });
        },
        Content({ vehicle, data, documents }) {
            if (vehicle.ref !== 'vin' || !data) {
                return null;
            }
            return React__default.createElement(CampaignsVehicleTab, { vehicle: vehicle, preloadedCampaigns: data, preloadedDocuments: documents, getDocumentUrl: documentId => {
                    return joinPath('/briefcase', getVehicleRoot(vehicle), `documents/${documentId}`);
                } });
        }
    };
}

function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case './strings/de.strings.ts': return import('./chunks/de.strings-11d1e007.js');
    case './strings/en.strings.ts': return import('./chunks/en.strings-a00740f9.js');
    case './strings/es.strings.ts': return import('./chunks/es.strings-461b5942.js');
    case './strings/fr.strings.ts': return import('./chunks/fr.strings-e57e6ffb.js');
    case './strings/hr.strings.ts': return import('./chunks/hr.strings-78a9e17b.js');
    case './strings/it.strings.ts': return import('./chunks/it.strings-abc2f6e1.js');
    case './strings/ja.strings.ts': return import('./chunks/ja.strings-a1113daf.js');
    case './strings/nl.strings.ts': return import('./chunks/nl.strings-e6aed240.js');
    case './strings/pl.strings.ts': return import('./chunks/pl.strings-7d264488.js');
    case './strings/pt.strings.ts': return import('./chunks/pt.strings-e9d3a36e.js');
    case './strings/ru.strings.ts': return import('./chunks/ru.strings-f3c52375.js');
    case './strings/sv.strings.ts': return import('./chunks/sv.strings-de36d760.js');
    case './strings/test.strings.ts': return import('./chunks/test.strings-5f97a443.js');
    case './strings/testrtl.strings.ts': return import('./chunks/testrtl.strings-2077ddd7.js');
    case './strings/zh.strings.ts': return import('./chunks/zh.strings-cb472927.js');
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }
const featureToggles = ['CAMPAIGN_BANNER_VISIBLE'];
function campaignsModule(props) {
    var _a;
    function showInSidebar(vehicle, dispatch) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (props === null || props === void 0 ? void 0 : props.alwaysShowInSidebar) {
                return true;
            }
            try {
                const campaigns = yield dispatch(campaignsApi.endpoints.getCampaigns.initiate(vehicle.vin)).unwrap();
                const count = (_a = campaigns.activeCount) !== null && _a !== void 0 ? _a : campaigns.campaigns.length;
                return count > 0;
            }
            catch (_b) {
                return true;
            }
        });
    }
    return {
        id: campaignsModuleId,
        overrides: props === null || props === void 0 ? void 0 : props.overrides,
        reducers,
        middleware,
        context: {
            iconResolver: props === null || props === void 0 ? void 0 : props.iconResolver,
            showFilters: (_a = props === null || props === void 0 ? void 0 : props.showFilters) !== null && _a !== void 0 ? _a : false
        },
        featureToggles,
        hooks: ({ strings, user, navigation, dispatch, isFeatureToggleEnabled }) => {
            const isEnabled = (user || (props === null || props === void 0 ? void 0 : props.visibleToGuestUsers)) && isFeatureToggleEnabled('CAMPAIGN_BANNER_VISIBLE');
            return {
                vehicleSidebarItems(vehicle) {
                    return __awaiter(this, void 0, void 0, function* () {
                        if (isEnabled && vehicle.ref === 'vin' && (yield showInSidebar(vehicle, dispatch))) {
                            return [
                                {
                                    title: strings.campaigns.title,
                                    href: navigation.vehicle(vehicle) + '/campaigns',
                                    group: 'campaigns',
                                    content() {
                                        return React__default.createElement(CampaignsSidebarItem, { vehicle: vehicle });
                                    }
                                }
                            ];
                        }
                        return [];
                    });
                },
                vehicleTabs: (vehicle) => __awaiter(this, void 0, void 0, function* () {
                    if (isEnabled && vehicle.ref === 'vin') {
                        return [
                            {
                                title: strings.campaigns.title,
                                href: '/campaigns',
                                adornment() {
                                    return React__default.createElement(CampaignsBadge, { vehicle: vehicle });
                                },
                                content() {
                                    return React__default.createElement(CampaignsVehicleTab, { vehicle: vehicle });
                                },
                                fallback() {
                                    return React__default.createElement(CampaignsVehicleTabSkeleton, null);
                                }
                            }
                        ];
                    }
                    return [];
                }),
                logOut() {
                    return __awaiter(this, void 0, void 0, function* () {
                        dispatch(campaignsApi.util.resetApiState());
                    });
                }
            };
        },
        strings(language) {
            return __awaiter(this, void 0, void 0, function* () {
                if (language === 'zz') {
                    language = 'test';
                }
                else if (language === 'ar') {
                    language = 'testrtl';
                }
                try {
                    // File extension required by @rollup/plugin-dynamic-import-vars.
                    return (yield __variableDynamicImportRuntime0__(/* webpackChunkName: '[request]' */ `./strings/${language}.strings.ts`)).default;
                }
                catch (_a) {
                    return (yield import(/* webpackChunkName: '[request]' */ './chunks/en.strings-a00740f9.js')).default;
                }
            });
        }
    };
}

export { campaignsBriefcaseExtension, campaignsModule };
